export enum ThumbnailType {
  REGULAR = 'regular',
  BOUND_SET = 'boundSet',
  RELATED_SET = 'relatedSet',
  LEDGER_SET = 'ledgerSet',
  IMAGE_SET = 'imageSet'
  // Future types
}

export interface ThumbnailTemplateConfig {
  type: ThumbnailType;
  templatePath: string;
  imageSize: { width: string; height: string };
  imageTransform?: string;
}

export const THUMBNAIL_TEMPLATES: { [key in ThumbnailType]: ThumbnailTemplateConfig } = {
  [ThumbnailType.REGULAR]: {
    type: ThumbnailType.REGULAR,
    templatePath: '',
    imageSize: { width: '100%', height: '100%' }
  },
  [ThumbnailType.BOUND_SET]: {
    type: ThumbnailType.BOUND_SET,
    templatePath: '/assets/Letter-Stack-Bound.png',
    imageSize: { width: '75%', height: '75%' }
  },
  [ThumbnailType.RELATED_SET]: {
    type: ThumbnailType.RELATED_SET,
    templatePath: '/assets/Letter-Stack.png',
    imageSize: { width: '75%', height: '75%' }
  },
  [ThumbnailType.LEDGER_SET]: {
    type: ThumbnailType.LEDGER_SET,
    templatePath: '/assets/Ledger_Template.png',
    imageSize: { width: '83%', height: '125%' },
    imageTransform: 'translate(-50%, -52%) rotateX(45deg)'
  },
  [ThumbnailType.IMAGE_SET]: {
    type: ThumbnailType.IMAGE_SET,
    templatePath: '/assets/Letter-Stack.png',
    imageSize: { width: '75%', height: '75%' }
  }
};